import React, { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import BackComponent from '../../../components/BackComponent'
import Label from '../../helpers/Label'
import Card from '../../helpers/Card'
import Input from '../../helpers/Input'
import LinkButton from '../../helpers/LinkButton'
import Loader from '../../Common/Loader'
import Validation from '../../helpers/Validation'
import { ArrowCircleLeft2 } from 'iconsax-react'
import CancelButton from '../../helpers/CancelButton'
import SaveButton from '../../helpers/SaveButton'
import { ClearInfo } from '../../../Encapsulation/Utils'
import flasher from '@flasher/flasher'
import { GetGAAProject } from '../../../Encapsulation/HotelDomainEntities/Hotel Master/GAAProject'
import { GetHotelAmenities, SaveHotelAmenities } from '../../../Encapsulation/HotelDomainEntities/HotelAmenities'

function AmenitiesAddEdit({ Rights }) {
  let formMode = "New";
  let { id } = useParams();
  {
    if (id) {
      document.title = "Hotel - Edit Amenities";
      formMode = "Edit";
    } else {
      document.title = "Hotel - Add Amenities";
    }
  }
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const Navigation = useNavigate();
  const Location = useLocation()
  const [formInfo, setFormInfo] = useState({});

  const handleChange = (e) => {
    setFormInfo((formInfo) => ({
      ...formInfo,
      [e.target.name]: e.target.value,
    }));
  };

// Save All Data To Server //
  const handleSubmit = async (e) => {
    e.preventDefault();
    let result = await SaveHotelAmenities(id, formInfo, []);
    if (result.Successful == false) {
      flasher.warning(result.Message);
    } else {
      flasher.success("Data Added Successfully");
      if (formMode == "Edit") {
        Navigation("/amenities");
      } else {
        setFormInfo(ClearInfo(formInfo));
        fetchProject();                   // Save ProjectRef 
      }
      console.log("result :", result);
    }
  };

    // Fetch project Details Using Location State //
  const fetchProject = async () => {
    let Project = await GetGAAProject(Location.state);
    setFormInfo(formInfo => ({
      ...formInfo,
      GAAProjectRef: Project.Ref,
      GAAProjectName: Project.Name
    }))
  };


  const fetchAmenities = async () => {
    let data = await GetHotelAmenities(id)
    setFormInfo(data);
}

// Fetch project Details Using Location State //
  useEffect(() => {
    if (Location.state) {
      fetchProject();
    }
    if(id)
    {         
      fetchAmenities();
    }
  }, []);
  

  return (
    <Fragment>
      {loader ? (
        <Loader />
      ) : (
        <BackComponent
          title={id ? "Edit Amenities" : "Add Amenities"}
          button={
            <LinkButton to={"/amenities"}>
              <ArrowCircleLeft2
                variant="Bold"
                className="w-5 h-5 text-default-color"
              />
            </LinkButton>
          }
        >
          <div className="flex items-center justify-center">
            <Card className={"w-full p-6"}>
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <Label htmlFor={"GAAProjectName"} labelText={"Project Name"} />
                    {formInfo.GAAProjectRef && (<Input
                      id={"GAAProjectName"}
                      type={"text"}
                      name={"GAAProjectName"}
                      value={formInfo.GAAProjectName}
                      required={true}
                      readOnly={true}
                    />
                    )}
                  </div>
                  <div>
                    <Label htmlFor={"Name"} labelText={"Name"} />
                    <Input
                      id={"Name"}
                      type={"text"}
                      name={"Name"}
                      value={formInfo.Name }
                      inputFocus={true}
                      onChange={handleChange}
                      required={true}
                      readOnly={!Rights.Edit}

                    />
                    <Validation error={errors.Name} />
                  </div>
                  <div>
                    <Label htmlFor={"VideoUrl"} labelText={"Video URL"} />
                    <Input
                      id={"VideoUrl"}
                      type={"text"}
                      name={"VideoUrl"}
                      value={formInfo.VideoUrl}
                      onChange={handleChange}
                      required={true}
                      readOnly={!Rights.Edit}

                    />
                    <Validation error={errors.VideoUrl} />
                  </div>
                  <div>
                    <Label htmlFor={"FromTime"} labelText={"From Time"} />
                    <Input
                      id={"FromTime"}
                      type={"time"}
                      name={"FromTime"}
                      value={formInfo.FromTime}
                      onChange={handleChange}
                      required={true}
                      readOnly={!Rights.Edit}
                    />
                    <Validation error={errors.FromTime} />
                  </div>
                  <div>
                    <Label htmlFor={"ToTime"} labelText={"To Time"} />
                    <Input
                      id={"ToTime"}
                      type={"time"}
                      name={"ToTime"}
                      value={formInfo.ToTime}
                      onChange={handleChange}
                      required={true}
                      readOnly={!Rights.Edit}
                    />
                    <Validation error={errors.ToTime} />
                  </div>
                  <div>
                    <Label htmlFor={"Description"} labelText={"Description"} />
                    <Input
                      id={"Description"}
                      type={"text"}
                      name={"Description"}
                      value={formInfo.Description}
                      onChange={handleChange}
                      required={true}
                      readOnly={!Rights.Edit}
                    />
                    <Validation error={errors.Description} />
                  </div>
                </div>
                <div className="flex gap-8 justify-center mt-6">
                  <CancelButton to={"/amenities"} />
                  {Rights.Edit && <SaveButton text="Save" />}
                </div>
              </form>
            </Card>
          </div>
        </BackComponent>
      )}
    </Fragment>
  );
}

export default AmenitiesAddEdit;
